export function isEmptyObject(obj: any) {
  return Object.keys(obj).length === 0;
}